import React, { useState } from "react";
import { useForm } from "react-hook-form";
import apiFunctions from "../../../Services/apiFunctions";
import * as moment from "moment";
import { history } from "../../../Healper/history";
import UserData from "./userData";

function PreliminaryData(props) {
  const Swal = require("sweetalert2");
  const [submitDisable, setSubmitDisable] = useState(false);
  const [data, setData] = useState("");
  const [showErrors, setShowErrors] = useState(false);
  const [validationErrors, setValidationErrors] = useState([]);
  /* useEffect(() => {
    if (
      props.location.state === undefined ||
      props.location.state.email === undefined
    )
      history.push("/");
    else {
      setEmail(props.location.state.email);
    }
  }, []); */
  const checkValidity = () => {
    let temp = [];
    try {
      if (data === "")
        temp.push(
          <div className="col-12 alert alert-danger">
            Please fill all information
          </div>
        );
      if (data.firstName.trim() === "")
        temp.push(
          <div className="col-12 alert alert-danger">
            Firsname can not be empty
          </div>
        );
      if (data.lastName.trim() === "")
        temp.push(
          <div className="col-12 alert alert-danger">
            Lastname can not be empty
          </div>
        );

      if (data.dob === "") {
        temp.push(
          <div className="col-12 alert alert-danger">
            D.O.B can not be empty
          </div>
        );
      } else {
        var date = moment(data.dob, "MM/DD/YYYY");
        if (date.isValid() === false) {
          temp.push(
            <div className="col-12 alert alert-danger">Invalid D.O.B</div>
          );
        }
      }
      if (data.gender === 0)
        temp.push(
          <div className="col-12 alert alert-danger">Select your gender</div>
        );
      if (data.race === 0)
        temp.push(
          <div className="col-12 alert alert-danger">Select your race</div>
        );
      if (data.ethnicity === 0)
        temp.push(
          <div className="col-12 alert alert-danger">Select your ethnicity</div>
        );
      if (data.addressLine1.trim() === "")
        temp.push(
          <div className="col-12 alert alert-danger">
            Address can not be empty
          </div>
        );
      if (data.city.trim() === "")
        temp.push(
          <div className="col-12 alert alert-danger">City can not be empty</div>
        );
      if (data.state.trim() === "")
        temp.push(
          <div className="col-12 alert alert-danger">
            State can not be empty
          </div>
        );
      if (data.zip.trim() === "")
        temp.push(
          <div className="col-12 alert alert-danger">zip can not be empty</div>
        );
      if (data.phone.trim() === "")
        temp.push(
          <div className="col-12 alert alert-danger">
            Phone number can not be empty
          </div>
        );
      else {
        const re =
          /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/;
        if (re.test(data.phone) === false) {
          temp.push(
            <div className="col-12 alert alert-danger">
              Invalid Phone number
            </div>
          );
        }
      }
      if (data.email !== undefined && data.email.trim() !== "") {
        const re =
          /^[a-zA-Z0-9][-a-z-A-Z0-9._]+@([-a-z-A-Z0-9]+[.])+[a-zA-Z]{2,5}$/;
        if (re.test(data.email) === false) {
          temp.push(
            <div className="col-12 alert alert-danger">
              Invalid email address
            </div>
          );
        }
      }
      if (data.billingType === 0) {
        if (data.insName === 0)
          temp.push(
            <div className="col-12 alert alert-danger">
              Insurance can not be empty
            </div>
          );
        if (data.insID.trim() === "")
          temp.push(
            <div className="col-12 alert alert-danger">
              Insurance ID can not be empty
            </div>
          );
        if (data.insRel !== 0) {
          if (data.insSubName.trim() === "")
            temp.push(
              <div className="col-12 alert alert-danger">
                Insurance subscriber name can not be empty
              </div>
            );
          if (data.insSubDOB === "") {
            temp.push(
              <div className="col-12 alert alert-danger">
                Subsciber D.O.B can not be empty
              </div>
            );
          } else {
            var date1 = moment(data.insSubDOB, "MM/DD/YYYY");
            if (date1.isValid() === false) {
              temp.push(
                <div className="col-12 alert alert-danger">
                  Invalid subscriber D.O.B
                </div>
              );
            }
          }
        }
      }
      if (data.billingType === 1) {
        if (data.noInsChecked === false)
          temp.push(
            <div className="col-12 alert alert-danger">
              You need to read and accept no insurance note.
            </div>
          );
      }
      if (data.billingType === 2) {
        if (data.clientCode.trim() === "")
          temp.push(
            <div className="col-12 alert alert-danger">
              Client code can not be empty
            </div>
          );
      }
    } catch {}
    setValidationErrors(temp);
    if (temp.length > 0) return false;
    return true;
  };
  const onSubmit = () => {
    if (checkValidity() === false) {
      setShowErrors(true);
      return;
    }
    setSubmitDisable(true);
    apiFunctions
      .saveData("PreliminaryData/Save", {
        ...data,
        dob: new Date(data.dob).toDateString(),
      })
      .then((response) => {
        if (response.code === 0) {
          history.push({
            pathname: "/PatientPreliminaryCode",
            state: { code: response.message },
          });
        } else {
          //swal("Error", "Error in Saving!", "error");
          Swal.fire({
            position: "top-end",
            icon: "error",
            title: "Error! Please check your connection and try again",
            showConfirmButton: false,
            timer: 1500,
          });
          setSubmitDisable(false);
        }
      });
  };
  const onDataChanged = (d) => {
    setData(d);
  };
  const { handleSubmit } = useForm({
    mode: "onBlur",
    reValidateMode: "onBlur",
  });
  return (
    <>
      <div className="mx-auto px-2">
        <UserData onDataChanged={onDataChanged}></UserData>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div>
            {showErrors && (
              <div className="pl-0 col-12 px-2">
                <div className="mx-auto px-2">
                  <div
                    style={{ marginTop: "10px" }}
                    className=" col-md-12 col-sx-12 col-lg-12 col-sm-12"
                  >
                    <div className="card">
                      <div className="card-body">
                        <div className="card px-2 ">
                          {validationErrors.map((e) => {
                            return e;
                          })}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            <div className="mt-3 mr-0 col-xs-6 col-sm-6 col-lg-2 offset-lg-10 col-md-2 offset-md-10">
              <button
                disabled={submitDisable}
                className="btn btn-block btn-primary "
                type="submit"
              >
                Save
              </button>
            </div>
          </div>
        </form>
      </div>
    </>
  );
}
export default PreliminaryData;
